const SORTORDER = {
  ASC: 'ascending',
  DESC: 'descending'
}

export {
  SORTORDER
}